const isBrowserDevRuntime = () => {
  if (typeof window === 'undefined') {
    return false
  }

  if (process.env.NODE_ENV === 'development') {
    return true
  }

  return process.env.NETLIFY_DEV === 'true'
}

export const devLog = (
  prefix: string,
  event: string,
  metadata?: Record<string, unknown> | null
) => {
  if (!isBrowserDevRuntime()) {
    return
  }

  console.log(prefix, event, metadata || {})
}
